/* eslint-disable no-bitwise */
export enum EmailFlag {
  Verified = 1 << 0,
  Bounced = 1 << 6,
  NotAuthorized = 1 << (51 - 32),
  AlwaysValidated = 1 << (50 - 32)
}
